export const OPEN_SUBMENU = 'OPEN_SUBMENU';
export const OPEN_SUBMENU_ITEM = 'OPEN_SUBMENU_ITEM';

export const CHANGE_DATE = 'CHANGE_DATE';
export const SHOW_LOADER = 'SHOW_LOADER';
export const USER_LOADER = 'USER_LOADER';
export const EDITOR = 'EDITOR';
export const SHOWCALENDAR = "SHOWCALENDAR";
export const SHOW_FILTER = "SHOW_FILTER";

export const SUCCESS_DASHBOARD_SUMMARY = 'SUCCESS_DASHBOARD_SUMMARY';
export const SUCCESS_TIME_SHEET_SUMMARY = 'SUCCESS_TIME_SHEET_SUMMARY';
export const FAILED_DASHBOARD_SUMMARY = 'FAILED_DASHBOARD_SUMMARY';
export const SUCCESS_DASHBOARD_SUMMARY_SINGLE_DATE = 'SUCCESS_DASHBOARD_SUMMARY_SINGLE_DATE';
export const FAILED_DASHBOARD_SUMMARY_SINGLE_DATE = 'FAILED_DASHBOARD_SUMMARY_SINGLE_DATE';

export const SUCCESS_DAY_WISE_TREND = 'SUCCESS_DAY_WISE_TREND';
export const FAILED_DAY_WISE_TREND = 'FAILED_DAY_WISE_TREND';

export const SUCCESS_ATTENDANCE_TREND = 'SUCCESS_ATTENDANCE_TREND';
export const FAILED_ATTENDANCE_TREND = 'FAILED_ATTENDANCE_TREND';

export const SUCCESS_CATEGORY_LIST = 'SUCCESS_CATEGORY_LIST';
export const FAILED_CATEGORY_LIST = 'FAILED_CATEGORY_LIST';

export const SUCCESS_CATEGORY_APP_WEB = 'SUCCESS_CATEGORY_APP_WEB';
export const FAILED_CATEGORY_APP_WEB = 'FAILED_CATEGORY_APP_WEB';
export const LOADING_CATEGORY_APP_WEB="LOADING_CATEGORY_APP_WEB";

export const SUCCESS_APP_WEB_LIST = 'SUCCESS_APP_WEB_LIST';
export const FAILED_APP_WEB_LIST = 'FAILED_APP_WEB_LIST';

export const SUCCESS_TIMELINE = 'SUCCESS_TIMELINE';
export const FAILED_TIMELINE = 'FAILED_TIMELINE';
export const FETCH_TIMELINE = 'FETCH_TIMELINE';

export const SUCCESS_HOURLY_TIMELINE = 'SUCCESS_HOURLY_TIMELINE';
export const FAILED_HOURLY_TIMELINE = 'FAILED_HOURLY_TIMELINE';

export const SUCCESS_LOGIN = 'SUCCESS_LOGIN';
export const FAILED_LOGIN = 'FAILED_LOGIN';
export const REMOVE_FAILED_MSG = 'REMOVE_FAILED_MSG';
export const SAVE_USER_DETAILS = 'SAVE_USER_DETAILS';
//calendar details
export const CALENDAR_DETAILS = 'CALENDAR_DETAILS';
export const FAILED_CALENDAR_DETAILS = 'FAILED_CALENDAR_DETAILS';

//Get Profile
export const GET_PROFILE_DETAIL = 'GET_PROFILE_DETAIL';
export const FAILD_PROFILE_DETAIL = 'FAILD_PROFILE_DETAIL';

//report
export const SUCCESS_REPORT = 'SUCCESS_REPORT';
export const FAILURE_REPORT = 'FAILURE_REPORT';

export const SUCCESS_TABLE_REPORT = 'SUCCESS_TABLE_REPORT';
export const FAILURE_TABLE_REPORT = 'FAILURE_TABLE_REPORT';

export const SUCCESS_SUBMIT_REPORT = 'SUCCESS_SUBMIT_REPORT';
export const FAILURE_SUBMIT_REPORT = 'FAILURE_SUBMIT_REPORT';

export const CARDID_CHANGE = 'CARDID_CHANGE';

export const SUCCESS_SEARCH_APPLICATION_DROPDOWN = 'SUCCESS_SEARCH_APPLICATION_DROPDOWN'
export const FAILURE_SEARCH_APPLICATION_DROPDOWN = 'FAILURE_SEARCH_APPLICATION_DROPDOWN'

export const LOADING_REPORT_TABLE = 'LOADING_REPORT_TABLE'


//Get Users
export const GET_USER_LIST = 'GET_USER_LIST';
export const FAILD_GET_USER_LIST = 'FAILD_GET_USER_LIST';
//Executive Summary
export const SUCCESS_DATE_WISE_DISTRIBUTION = 'SUCCESS_DATE_WISE_DISTRIBUTION';
export const FAILED_DATE_WISE_DISTRIBUTION = 'FAILED_DATE_WISE_DISTRIBUTION';

export const SUCCESS_DAILY_IN_OUT = 'SUCCESS_DAILY_IN_OUT';
export const FAILED_DAILY_IN_OUT = 'FAILED_DAILY_IN_OUT';

export const SUCCESS_DATE_WISE_ACTIVE_PRODUCTIVE = 'SUCCESS_DATE_WISE_ACTIVE_PRODUCTIVE';
export const FAILED_DATE_WISE_ACTIVE_PRODUCTIVE = 'FAILED_DATE_WISE_ACTIVE_PRODUCTIVE';

export const SUCCESS_BUSINESS_UNIT = 'SUCCESS_BUSINESS_UNIT';
export const FAILED_BUSINESS_UNIT = 'FAILED_BUSINESS_UNIT';
export const SUCCESS_LOCATION_WISE = 'SUCCESS_LOCATION_WISE';
export const SUCCESS_DESIGNATION_WISE = 'SUCCESS_DESIGNATION_WISE';
export const SUCCESS_ROLE_WISE = 'SUCCESS_ROLE_WISE';
export const SUCCESS_TEAM_WISE = 'SUCCESS_TEAM_WISE';
export const SUCCESS_GROUP_WISE = 'SUCCESS_GROUP_WISE';

export const SUCCESS_TOP_APPLICATION = 'SUCCESS_TOP_APPLICATION';
export const FAILED_TOP_APPLICATION = 'FAILED_TOP_APPLICATION';

export const SUCCESS_TOP_APP_TIME_SPLIT = 'SUCCESS_TOP_APP_TIME_SPLIT';
export const FAILED_TOP_APP_TIME_SPLIT = 'FAILED_TOP_APP_TIME_SPLIT';

export const SUCCESS_DASHBOARD_CARD = 'SUCCESS_DASHBOARD_CARD';
export const FAILED_DASHBOARD_CARD = 'FAILED_DASHBOARD_CARD';

export const SUCCESS_DASHBOARD_CARD_SINGLE_DATE = 'SUCCESS_DASHBOARD_CARD_SINGLE_DATE';
export const FAILED_DASHBOARD_CARD_SINGLE_DATE = 'FAILED_DASHBOARD_CARD_SINGLE_DATE';
export const SHOW_LOADER_EXECUTIVE_SUMMARY = 'SHOW_LOADER_EXECUTIVE_SUMMARY';

export const SUCCESS_ATTENDANCE_HEATMAP = 'SUCCESS_ATTENDANCE_HEATMAP';
export const FAILED_ATTENDANCE_HEATMAP = 'FAILED_ATTENDANCE_HEATMAP';

export const SUCCESS_ATTENDANCE_HEATMAP_CHILD = 'SUCCESS_ATTENDANCE_HEATMAP_CHILD';
export const FAILED_ATTENDANCE_HEATMAP_CHILD = 'FAILED_ATTENDANCE_HEATMAP_CHILD';
export const FETCH_ATTENDANCE_HEATMAP_CHILD = 'FETCH_ATTENDANCE_HEATMAP_CHILD';

export const SUCCESS_HOURLY_SPREAD = 'SUCCESS_HOURLY_SPREAD';
export const FAILED_HOURLY_SPREAD = 'FAILED_HOURLY_SPREAD';

export const SUCCESS_HOURLY_SPREAD_CHILD = 'SUCCESS_HOURLY_SPREAD_CHILD';
export const FETCH_HOURLY_SPREAD_CHILD = 'FETCH_HOURLY_SPREAD_CHILD';
export const FAILED_HOURLY_SPREAD_CHILD = 'FAILED_HOURLY_SPREAD_CHILD';
export const SHOW_LOADER_DEEP_DIVE = 'SHOW_LOADER_DEEP_DIVE';


//Get Mapping User Dropdown
export const GET_FILTER = 'GET_FILTER';
export const FAILD_GET_FILTER = 'FAILD_GET_FILTER';

//Get All User
export const GET_ALL_USER = 'GET_ALL_USER';
export const FAILD_GET_ALL_USER = 'FAILD_GET_ALL_USER';

//Get Unauthorized User List
export const GET_UNAUTHORIZED_USER_LIST = 'GET_UNAUTHORIZED_USER_LIST';
export const FAILD_UNAUTHORIZED_USER_LIST = 'FAILD_UNAUTHORIZED_USER_LIST';

//loader Team
export const USER_LIST_LODE = 'USER_LIST_LODE';

export const SUCCESS_TOP_PRODUCTIVE = 'SUCCESS_TOP_PRODUCTIVE';
export const FAILED_TOP_PRODUCTIVE = 'FAILED_TOP_PRODUCTIVE';

export const SUCCESS_LEAST_PRODUCTIVE = 'SUCCESS_LEAST_PRODUCTIVE';
export const FAILED_LEAST_PRODUCTIVE = 'FAILED_LEAST_PRODUCTIVE';

export const SUCCESS_UTILIZATION = 'SUCCESS_UTILIZATION';
export const FAILED_UTILIZATION = 'FAILED_UTILIZATION';
//Organization
export const GET_TIMEZONE_LIST = "GET_TIMEZONE_LIST"
export const GET_COUNTRY_LIST = "GET_COUNTRY_LIST"

//application config
export const SUCCESS_APPLICATION_CATEGORY = 'SUCCESS_APPLICATION_CATEGORY';
export const FETCH_APPLICATION_CATEGORY = 'FETCH_APPLICATION_CATEGORY';
export const FAILED_APPLICATION_CATEGORY = 'FAILED_APPLICATION_CATEGORY';
export const DELETE_APPLICATION_CATEGORY = 'DELETE_APPLICATION_CATEGORY';
export const UPDATE_PRODUCTIVE_APPLICATION = 'UPDATE_PRODUCTIVE_APPLICATION';
export const REMOVE_UPDATE_APPLICATION_FLAG = 'REMOVE_UPDATE_APPLICATION_FLAG';


export const SUCCESS_APPLICATION = 'SUCCESS_APPLICATION';
export const FAILED_APPLICATION = 'FAILED_APPLICATION';
export const UPDATE_APPLICATION = 'UPDATE_APPLICATION';

export const SUCCESS_EXCEPTION_APPLICATION = 'SUCCESS_EXCEPTION_APPLICATION';
export const FAILED_EXCEPTION_APPLICATION = 'FAILED_EXCEPTION_APPLICATION';
export const UPDATE_ADD_EXCEPTION_APPLICATION = 'UPDATE_ADD_EXCEPTION_APPLICATION';
export const REMOVE_UPDATE_ADD_EXCEPTION_APPLICATION_FLAG = 'REMOVE_UPDATE_ADD_EXCEPTION_APPLICATION_FLAG';

export const SUCCESS_SEARCH_ADD_EXCEPTION_APPLICATION = 'SUCCESS_SEARCH_ADD_EXCEPTION_APPLICATION';
export const FAILED_SEARCH_ADD_EXCEPTION_APPLICATION = 'FAILED_SEARCH_ADD_EXCEPTION_APPLICATION';

export const LOADING_APPLICATION_LIST = 'LOADING_APPLICATION_LIST';
export const SUCCESS_APPLICATION_LIST = 'SUCCESS_APPLICATION_LIST';
export const FAILED_APPLICATION_LIST = 'FAILED_APPLICATION_LIST';

export const GET_ORGANIZATION = "GET_ORGANIZATION"

//Agent Configuration
export const GET_AGENTCONFIGURATION = "GET_AGENTCONFIGURATION"
export const EMPTY_AGENTCONFIGURATION = "EMPTY_AGENTCONFIGURATION"

//Screen shot Configuration
export const SUCCESS_SCREENSHOT_TABLE = "SUCCESS_SCREENSHOT_TABLE"
export const FETCH_SCREENSHOT_TABLE = "FETCH_SCREENSHOT_TABLE"
export const FAIL_SCREENSHOT_TABLE = "FAIL_SCREENSHOT_TABLE"
export const LOADING_SCREENSHOT_TABLE = "LOADING_SCREENSHOT_TABLE"
export const SUCCESS_SCREENSHOT_LIST = "SUCCESS_SCREENSHOT_LIST"
export const FAIL_SCREENSHOT_LIST = "FAIL_SCREENSHOT_LIST"
export const SORT_BY_FROMDATE_A_Z = "SORT_BY_FROMDATE_A_Z"
export const SORT_BY_FROMDATE_Z_A = "SORT_BY_FROMDATE_Z_A"
export const LOADING_SCREENSHOT_LIST = "LOADING_SCREENSHOT_LIST"
export const SCREENSHOT_TABLELOADER = "SCREENSHOT_TABLELOADER"

export const GET_PENDING_TEAM_REQUEST = "GET_PENDING_TEAM_REQUEST"
export const FAILED_PENDING_TEAM_REQUEST = "FAILED_PENDING_TEAM_REQUEST"

//Forgot password
export const SUCCESS_FORGOT_PASSWORD = 'SUCCESS_FORGOT_PASSWORD';
export const FAILED_FORGOT_PASSWORD = 'FAILED_FORGOT_PASSWORD';

export const SUCCESS_SEND_MAIL = 'SUCCESS_SEND_MAIL';
export const FAILED_SEND_MAIL = 'FAILED_SEND_MAIL';
export const FETCH_SEND_MAIL = 'FETCH_SEND_MAIL';

export const SUCCESS_RESEND_OTP = 'SUCCESS_RESEND_OTP';
export const FAILED_RESEND_OTP = 'FAILED_RESEND_OTP';
export const VERIFY_OTP_HIDE_MSG = 'VERIFY_OTP_HIDE_MSG';

export const SUCCESS_VERIFY_OTP = 'SUCCESS_VERIFY_OTP';
export const FAILED_VERIFY_OTP = 'FAILED_VERIFY_OTP';

export const SUCCESS_UPDATE_PASSWORD = 'SUCCESS_UPDATE_PASSWORD';
export const FAILED_UPDATE_PASSWORD = 'FAILED_UPDATE_PASSWORD';
export const UPDATE_PASSWORD_HIDE_MSG = 'UPDATE_PASSWORD_HIDE_MSG';

//payment
export const SUCCESS_GET_SUBCRIPTION_DETAILS = 'SUCCESS_GET_SUBCRIPTION_DETAILS';
export const FAIELD_GET_SUBCRIPTION_DETAILS = 'FAIELD_GET_SUBCRIPTION_DETAILS';

export const SUCCESS_GET_PAYMENT_INFO = 'SUCCESS_GET_PAYMENT_INFO';
export const FAILED_GET_PAYMENT_INFO = 'FAILED_GET_PAYMENT_INFO';

//Sustem Resources
export const SUCCESS_SYSTEM_RESOURCES_CARD = 'SUCCESS_SYSTEM_RESOURCES_CARD';
export const FAILED_SYSTEM_RESOURCES_CARD = 'FAILED_SYSTEM_RESOURCES_CARD';

export const SUCCESS_SYSTEM_RESOURCES_SINGLE_CARD = 'SUCCESS_SYSTEM_RESOURCES_SINGLE_CARD';
export const FAILED_SYSTEM_RESOURCES_SINGLE_CARD = 'FAILED_SYSTEM_RESOURCES_SINGLE_CARD';

export const SUCCESS_HOURLY_APPLICATION = 'SUCCESS_HOURLY_APPLICATION';
export const FAILED_HOURLY_APPLICATION = 'FAILED_HOURLY_APPLICATION';

export const SUCCESS_HOURLY_APPLICATION_CHILD = 'SUCCESS_HOURLY_APPLICATION_CHILD';
export const FAILED_HOURLY_APPLICATION_CHILD = 'FAILED_HOURLY_APPLICATION_CHILD';
export const FETCH_HOURLY_APPLICATION_CHILD = 'FETCH_HOURLY_APPLICATION_CHILD';

export const GET_RATE_CARD = "GET_RATE_CARD";
export const FAIELD_RATE_CARD = "FAIELD_RATE_CARD";

export const SUCCESS_APPLICATION_LIST_CATEGORY = 'SUCCESS_APPLICATION_LIST_CATEGORY';
export const FAILED_APPLICATION_LIST_CATEGORY = 'FAILED_APPLICATION_LIST_CATEGORY';
export const GET_PAYMENT_DETAILS = "GET_PAYMENT_DETAILS";

export const SUCCESS_WEB_LIST_CATEGORY = 'SUCCESS_WEB_LIST_CATEGORY';
export const FAILED_WEB_LIST_CATEGORY = 'FAILED_WEB_LIST_CATEGORY';

export const SUCCESS_TIME_SPLIT_CATEGORY = 'SUCCESS_TIME_SPLIT_CATEGORY';
export const FAILED_TIME_SPLIT_CATEGORY = 'FAILED_TIME_SPLIT_CATEGORY';

export const SUCCESS_WEB_TIME_SPLIT_CATEGORY = 'SUCCESS_WEB_TIME_SPLIT_CATEGORY';
export const FAILED_WEB_TIME_SPLIT_CATEGORY = 'FAILED_WEB_TIME_SPLIT_CATEGORY';

export const SHOW_LOADER_SYSTEM_RESOURCE = 'SHOW_LOADER_SYSTEM_RESOURCE';
export const LOADING_PRODUCTIVE_APPLICATION = "LOADING_PRODUCTIVE_APPLICATION"

//Get Users
export const GET_PROFILE_IMAGE = 'GET_PROFILE_IMAGE';
export const FAILD_GET_PROFILE_IMAGE = 'GET_PROFILE_IMAGE';

export const GET_USER_DETAILS_FOR_SUBSCRIPTION = "GET_USER_DETAILS_FOR_SUBSCRIPTION"

export const IS_AGENT_AVAILABLE = "IS_AGENT_AVAILABLE"

export const HIDE_NOTIFICATION_DAILY_TREND = 'HIDE_NOTIFICATION_DAILY_TREND';

export const GET_ALL_USER_LIST = "GET_ALL_USER_LIST";
export const FAILD_ALL_GET_USER_LIST = "FAILD_ALL_GET_USER_LIST";

export const FETCH_ALL_USER_LIST_OVERTIME = "FETCH_ALL_USER_LIST_OVERTIME";
export const SUCCESS_ALL_USER_LIST_OVERTIME = "SUCCESS_ALL_USER_LIST_OVERTIME";
export const FAILD_ALL_USER_LIST_OVERTIME = "FAILD_ALL_USER_LIST_OVERTIME";

export const EMPTY_PAYMENT_REDUCER = "EMPTY_PAYMENT_REDUCER";

export const LOADER_SUBMIT_REPORT = "LOADER_SUBMIT_REPORT";
export const COUNTRY_LIST_LOADING="COUNTRY_LIST_LOADING";
export const TIMEZONE_LIST_LOADING="TIMEZONE_LIST_LOADING";
export const ORGANIZATION_LOADING="ORGANIZATION_LOADING";
export const AGENTCONFIGURATION_LOADING="AGENTCONFIGURATION_LOADING";
export const DELETE_TABLE = "DELETE_TABLE"

export const SUCCESS_FILTER="SUCCESS_FILTER";
export const FAILED_FILTER="FAILED_FILTER";
export const FETCH_FILTER="FETCH_FILTER";

export const SAVE_FILTER_VALUE="SAVE_FILTER_VALUE";
export const GET_OFFLINETIME="GET_OFFLINETIME"
export const FAIL_OFFLINETIME="FAIL_OFFLINETIME"
export const LOADING_OFFLINETIME="LOADING_OFFLINETIME"
export const OFFLINETIME_REMOVEROW="OFFLINETIME_REMOVEROW"


export const SUCCESS_GET_APPLICATION_LIST="SUCCESS_GET_APPLICATION_LIST";
export const FAILED_GET_APPLICATION_LIST="FAILED_GET_APPLICATION_LIST";

export const SUCCESS_GET_RESTIRICTED_APP="SUCCESS_GET_RESTIRICTED_APP";
export const FAILED_GET_RESTIRICTED_APP="FAILED_GET_RESTIRICTED_APP";

export const LOADER_RESTIRICTED_APP="LOADER_RESTIRICTED_APP";

export const UPDATE_TIMELINE="UPDATE_TIMELINE";

export const SUCCESS_GET_SMTP_CONFIG="SUCCESS_GET_SMTP_CONFIG";
export const FAILED_GET_SMTP_CONFIG="FAILED_GET_SMTP_CONFIG";

export const LOADER_SMTP_APP="LOADER_SMTP_APP";
export const LOADING_OFFLINETIME_LOG="LOADING_OFFLINETIME_LOG"
export const GET_OFFLINETIME_LOG="GET_OFFLINETIME_LOG"
export const FAIL_OFFLINETIME_LOG="FAIL_OFFLINETIME_LOG"

export const SUCCESS_LICENSE="SUCCESS_LICENSE";
export const FAILED_LICENSE="FAILED_LICENSE";
export const FETCH_LICENSE="FETCH_LICENSE";

export const SUCCESS_GET_BULK_UPLOAD_LOG="SUCCESS_GET_BULK_UPLOAD_LOG";
export const FAILED_GET_BULK_UPLOAD_LOG="FAILED_GET_BULK_UPLOAD_LOG";
export const LODEAR_BULK_UPLOAD_LOG="LODEAR_BULK_UPLOAD_LOG";
export const DELETE_APPLICATION_LIST = "DELETE_APPLICATION_LIST"
export const EDIT_APPLICATION_LIST = "EDIT_APPLICATION_LIST"

export const SUCCESS_TIME_SHEET="SUCCESS_TIME_SHEET";
export const FAILED_TIME_SHEET="FAILED_TIME_SHEET";
export const FETCH_TIME_SHEET="FETCH_TIME_SHEET";
export const UPDATE_DATE_TIME_SHEET="UPDATE_DATE_TIME_SHEET";

export const LOADER_WORK_TIME = "LOADER_WORK_TIME";
export const GET_WORK_TIME = "GET_WORK_TIME";
export const FAILED_WORK_TIME = "FAILED_WORK_TIME";

export const SUCCESS_GET_LEAVE = 'SUCCESS_GET_LEAVE';
export const FAILED_GET_LEAVE = 'FAILED_GET_LEAVE';
export const FETCH_GET_LEAVE = 'FETCH_GET_LEAVE';

export const FETCH_CHANGE_PRODUCTIVE = 'FETCH_CHANGE_PRODUCTIVE';
export const SAVE_CHANGE_PRODUCTIVE = 'SAVE_CHANGE_PRODUCTIVE';

export const SUCCESS_GET_DASHBOARD_DELEGATION = 'SUCCESS_GET_DASHBOARD_DELEGATION';
export const FAILED_GET_DASHBOARD_DELEGATION = 'FAILED_GET_DASHBOARD_DELEGATION';
export const FETCH_GET_DASHBOARD_DELEGATION = 'FETCH_GET_DASHBOARD_DELEGATION';

export const GET_REPORTING_WISE_LIST = 'GET_REPORTING_WISE_LIST';
export const FAILD_REPORTING_WISE_LIST = 'FAILD_REPORTING_WISE_LIST';

export const SUCCESS_USER_COUNT = 'SUCCESS_USER_COUNT';
export const FAILED_USER_COUNT = 'FAILED_USER_COUNT';
export const CHANGE_USER_COUNT = 'CHANGE_USER_COUNT';

export const SUCCESS_ABSENCE_RPORT = 'SUCCESS_ABSENCE_RPORT';
export const FAILED_ABSENCE_REPORT = 'FAILED_ABSENCE_REPORT';
export const LOADING_ABSENCE_REPORT = 'LOADING_ABSENCE_REPORT';


export const SUCCESS_TRAKZO_LITE = 'SUCCESS_TRAKZO_LITE';
export const FAILED_TRAKZO_LITE = 'FAILED_TRAKZO_LITE';
export const LOADING_TRAKZO_LITE = 'LOADING_TRAKZO_LITE';
export const SUCCESS_ASSET_DETAILS = 'SUCCESS_ASSET_DETAILS';
export const FAILED_ASSET_DETAILS = 'FAILED_ASSET_DETAILS';
export const LOADING_ASSET_DETAILS = 'LOADING_ASSET_DETAILS';

export const SUCCESS_WORKINGHOUR_PROFILE = 'SUCCESS_WORKINGHOUR_PROFILE';
export const FAILED_WORKINGHOUR_PROFILE = 'FAILED_WORKINGHOUR_PROFILE';
export const SUCCESS_MAILSCHEDULE = 'SUCCESS_MAILSCHEDULE';
export const FAILED_MAILSCHEDULE = 'FAILED_MAILSCHEDULE';
export const LOADING_MAILSCHEDULE = 'LOADING_MAILSCHEDULE';
export const SUCCESS_MAILSCHEDULE_TABLE = 'SUCCESS_MAILSCHEDULE_TABLE';
export const FAILED_MAILSCHEDULE_TABLE = 'FAILED_MAILSCHEDULE_TABLE';
export const LOADING_MAILSCHEDULE_TABLE = 'LOADING_MAILSCHEDULE_TABLE';

export const LOADING_GENERICHOLIDAY = 'LOADING_GENERICHOLIDAY';
export const FAIL_GENERICHOLIDAY = 'FAIL_GENERICHOLIDAY';
export const GET_GENERICHOLIDAY = 'GET_GENERICHOLIDAY';
export const LOADING_GENERICHOLIDAY_STATUS = 'LOADING_GENERICHOLIDAY_STATUS';
export const FAIL_GENERICHOLIDAY_STATUS = 'FAIL_GENERICHOLIDAY_STATUS';
export const GET_GENERICHOLIDAY_STATUS = 'GET_GENERICHOLIDAY_STATUS';
export const REMOVE_DEVICE_COUNT = 'REMOVE_DEVICE_COUNT';
export const GET_CAPACITY_PLAN="GET_CAPACITY_PLAN";
export const GET_CAPACITY_PLAN_ADD_PROJECT="GET_CAPACITY_PLAN_ADD_PROJECT";
export const GET_CAPACITY_PLAN_GET_MONTH="GET_CAPACITY_PLAN_GET_MONTH";
export const GET_CAPACITY_PLAN_CHANGE_LEVEL="GET_CAPACITY_PLAN_CHANGE_LEVEL";

export const LOAD_ALL_SKILLSET = 'LOAD_ALL_SKILLSET';
export const LOAD_ALL_SKILLS = 'LOAD_ALL_SKILLS';
export const ADD_SKILLS = 'ADD_SKILLS';
export const ADD_SKILLSET = 'ADD_SKILLSET';

export const SUCCESS_ATTENDANCE="SUCCESS_ATTENDANCE";
export const FAILED_ATTENDANCE="FAILED_ATTENDANCE";
export const FETCH_ATTENDANCE="FETCH_ATTENDANCE";
export const LOADING_ATTENDANCE="LOADING_ATTENDANCE";

export const UPDATE_USER_LIST_TAB="UPDATE_USER_LIST_TAB";
export const SUCCESS_SKILLSETITEMS_ADD = 'SUCCESS_SKILLSETITEMS_ADD';
export const SUCCESS_SKILLSET_ADD = 'SUCCESS_SKILLSET_ADD';
export const GET_EMPLOYEES_UTILIZATION = "GET_EMPLOYEES_UTILIZATION";

export const ADD_UPDATE_EMPLOYEE_DETAILS_RESP = 'ADD_UPDATE_EMPLOYEE_DETAILS_RESP';

export const FETCH_HOLIDAY_DETAILS_FOR_MYDASHBOARD="FETCH_HOLIDAY_DETAILS_FOR_MYDASHBOARD"
export const GET_HOLIDAY_DETAILS_FOR_MYDASHBOARD="GET_HOLIDAY_DETAILS_FOR_MYDASHBOARD";
export const FAILED_HOLIDAY_DETAILS_FOR_MYDASHBOARD="FAILED_HOLIDAY_DETAILS_FOR_MYDASHBOARD";



export const DAILY_TREND_LOADER_CAP_DASHBOARD = 'DAILY_TREND_LOADER_CAP_DASHBOARD';
export const WEEK_TREND__LOADER_CAP_DASHBOARD = 'WEEK_TREND__LOADER_CAP_DASHBOARD';
export const CARD_DATA__LOADER_CAP_DASHBOARD = 'CARD_DATA__LOADER_CAP_DASHBOARD';
export const MOST_ACTIVE_PROJ__LOADER_CARD_DATA_CAP_DASHBOARD = 'MOST_ACTIVE_PROJ__LOADER_CARD_DATA_CAP_DASHBOARD';
export const MOST_ACTIVE_EMP__LOADER_CARD_DATA_CAP_DASHBOARD = 'MOST_ACTIVE_EMP__LOADER_CARD_DATA_CAP_DASHBOARD';
export const UTILIZATION_CURRENT_MONTH__LOADER_CAP_DASHBOARD = 'UTILIZATION_CURRENT_MONTH__LOADER_CAP_DASHBOARD';
export const GET_FAILED_EMPLOYEE_VIEW = 'GET_FAILED_EMPLOYEE_VIEW';

export const COMPLETE_TASK = 'COMPLETE_TASK';
export const UPDATE_TASK_LOADER = 'UPDATE_TASK_LOADER';
export const LOAD_TASK_TIME_SPENT = 'LOAD_TASK_TIME_SPENT';
export const UPDATE_TASK_SUCCESS = 'UPDATE_TASK_SUCCESS';
export const UPDATE_TASK_SPENT_TIME = 'UPDATE_TASK_SPENT_TIME';
export const COMPLETE_TASK_LOADER = 'COMPLETE_TASK_LOADER';


export const CARD_DATA_CAP_DASHBOARD = 'CARD_DATA_CAP_DASHBOARD';
export const DAILY_TREND_CAP_DASHBOARD = 'DAILY_TREND_CAP_DASHBOARD';

export const WEEK_TREND_CAP_DASHBOARD = 'WEEK_TREND_CAP_DASHBOARD';
export const GET_CAPACITY_PLAN_LOADING="GET_CAPACITY_PLAN_LOADING";


export const GET_UPDATE_ROLE = 'GET_UPDATE_ROLE';


export const MOST_ACTIVE_PROJ_CARD_DATA_CAP_DASHBOARD = 'MOST_ACTIVE_PROJ_CARD_DATA_CAP_DASHBOARD';

export const MOST_ACTIVE_EMP_CARD_DATA_CAP_DASHBOARD = 'MOST_ACTIVE_EMP_CARD_DATA_CAP_DASHBOARD';

export const UTILIZATION_CURRENT_MONTH_CAP_DASHBOARD = 'UTILIZATION_CURRENT_MONTH_CAP_DASHBOARD';
export const FAILED_TEAM_WISE = 'FAILED_TEAM_WISE';
export const SUCCESS_MONTH_WISE_DISTRIBUTION = 'SUCCESS_MONTH_WISE_DISTRIBUTION';
export const FAILED_MONTH_WISE_DISTRIBUTION = 'FAILED_MONTH_WISE_DISTRIBUTION';
export const SUCCESS_WEEK_WISE_DISTRIBUTION = 'SUCCESS_WEEK_WISE_DISTRIBUTION';
export const FAILED_WEEK_WISE_DISTRIBUTION = 'FAILED_WEEK_WISE_DISTRIBUTION';


export const SUCCESS_GETUSER_BULK_UPLOAD_LOG="SUCCESS_GETUSER_BULK_UPLOAD_LOG";
export const FAILED_GETUSER_BULK_UPLOAD_LOG="FAILED_GETUSER_BULK_UPLOAD_LOG";
export const LODEAR_BULKUSER_UPLOAD_LOG="LODEAR_BULKUSER_UPLOAD_LOG";


export const SUCCESS_GETINACTIVATEUSER_BULK_UPLOAD_LOG="SUCCESS_GETINACTIVATEUSER_BULK_UPLOAD_LOG";
export const FAILED_GETINACTIVATEUSER_BULK_UPLOAD_LOG="FAILED_GETINACTIVATEUSER_BULK_UPLOAD_LOG";
export const LODEAR_BULKINACTIVATEUSER_UPLOAD_LOG="LODEAR_BULKINACTIVATEUSER_UPLOAD_LOG";
export const GET_LATEST_TRANSACTIONS = "GET_LATEST_TRANSACTIONS";
export const FAILED_LATEST_TRANSACTIONS = "FAILED_LATEST_TRANSACTIONS";
export const LOADING_LATEST_TRANSACTIONS = "FAILED_LATEST_TRANSACTIONS";
